var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-duplicate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08376 6.08376C6.51413 3.75992 8.55154 2 11 2H17C19.7614 2 22 4.23858 22 7V13C22 15.4485 20.2401 17.4859 17.9162 17.9162C17.4859 20.2401 15.4485 22 13 22H7C4.23858 22 2 19.7614 2 17V11C2 8.55154 3.75992 6.51413 6.08376 6.08376ZM8.17071 6H13C15.7614 6 18 8.23858 18 11V15.8293C19.1652 15.4175 20 14.3062 20 13V7C20 5.34315 18.6569 4 17 4H11C9.69378 4 8.58254 4.83481 8.17071 6ZM7 8C5.34315 8 4 9.34315 4 11V17C4 18.6569 5.34315 20 7 20H13C14.6569 20 16 18.6569 16 17V11C16 9.34315 14.6569 8 13 8H7Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5e5e1ecca89d65c6faa21c71ca6a4dbc.svg";
export { ForwardRef as ReactComponent };